import * as React from "react";
import { useTranslation } from "react-i18next";
import { Alert, Col, Row } from "components/bootstrap";
import useLicenseCheck from "license/useLicenseCheck";
import LicenseHelp from "license/notifications/LicenseHelp";
const Status = () => {
  const { t } = useTranslation("enterprise_security_assets");
  return /* @__PURE__ */ React.createElement(Alert, { bsStyle: "danger", title: t("events_security_license_status.title") }, /* @__PURE__ */ React.createElement("p", null, t("events_security_license_status.description")), /* @__PURE__ */ React.createElement(LicenseHelp, null));
};
const EventsSecurityLicenseStatus = ({ summary = false, children = void 0 }) => {
  const {
    security: { isValid }
  } = useLicenseCheck();
  if (summary) return /* @__PURE__ */ React.createElement(Status, null);
  return /* @__PURE__ */ React.createElement(Row, { className: "row-sm" }, /* @__PURE__ */ React.createElement(Col, { md: 12 }, isValid ? children : /* @__PURE__ */ React.createElement(Status, null)));
};
export default EventsSecurityLicenseStatus;
